// extracted by mini-css-extract-plugin
export default {"Options":"EditRevisionWarningModal_Options__aiYar"};